import React from 'react';
import { Helmet } from 'react-helmet-async';
import TaskStatus from '../../sections/manager/tasks/task-status'

const TaskStatusPage = () => {
  return (
    <>
      <Helmet title="Task Message Status" />
      <TaskStatus />
    </>
  );
};

export default TaskStatusPage;
